// eslint-disable-next-line import/no-anonymous-default-export
export default {
  primaryColor: '#166649',
  secondaryColor: '#ab934b',
  error: '#C71F37',
  success: '#00de9f',
  background: '#FFFFFF',
  onBackground: '#eceeef',
  buttonPresse: '#004431',
  textColor: '#555',
  lightGrey: '#f8f8f8',
  fontDefault:
    "'Roboto', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
};
